import { render } from "./PosterPreviewPage.vue?vue&type=template&id=65cdae2d&scoped=true&ts=true"
import script from "./PosterPreviewPage.vue?vue&type=script&lang=ts"
export * from "./PosterPreviewPage.vue?vue&type=script&lang=ts"

import "./PosterPreviewPage.vue?vue&type=style&index=0&id=65cdae2d&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/democratielab-poster/democratielab-poster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65cdae2d"]])

export default __exports__